import * as React from 'react';

const Loading = ({ isLoading, children }) => {
    if ( isLoading ) {
        return (
            <div className="pfa-loading">
                <div className="pfa-loading__spinner" />
            </div>
        )
    } else {
        return <>{children}</>
    }
}

Loading.displayName = 'Loading';

export default Loading;